module.exports = __webpack_public_path__ + "files/663ebbd8825163906b2ecb11a6c2769a.png";